import { render } from "./ClockComponent.vue?vue&type=template&id=8b472126"
import script from "./ClockComponent.vue?vue&type=script&lang=js"
export * from "./ClockComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__